// DAS-2181: Terminal Hero Strip — renders 6 hero cells from card terminal.hero data
import React from 'react';
import { ANNOTATION_REGIONS } from './terminalZoneConfig';

const TerminalHero = ({ cards, heroConfig, onCardClick, annotationMode, onAnnotationClick, annotations = [] }) => {
  const getAnnotationCount = (regionId) =>
    annotations.filter(a => a.region === regionId && a.status === 'open').length;

  return (
    <div className="hero">
      {heroConfig.map((cell) => {
        const card = cards.find(c => c.id === cell.cardId);
        const hero = card?.terminal?.hero;
        if (!hero) return <div className="hero-cell" key={cell.cardId} />;

        const regionId = ANNOTATION_REGIONS.hero(cell.cardId);
        const annCount = getAnnotationCount(regionId);

        const handleClick = () => {
          if (annotationMode) {
            onAnnotationClick?.(regionId, hero.label);
          } else if (cell.modal) {
            onCardClick?.(cell.modal);
          }
        };

        return (
          <div
            className={`hero-cell annotatable${annotationMode ? ' annotation-mode' : ''}`}
            key={cell.cardId}
            onClick={handleClick}
            data-region={regionId}
          >
            {cell.modal && !annotationMode && (
              <span className="click-hint">{`\u2192 ${cell.modal}`}</span>
            )}
            {annotationMode && annCount > 0 && <span className="annotation-badge">{annCount}</span>}

            <div className="h-lbl">{hero.label}</div>

            {hero.inlineGroup ? (
              <div className="hero-inline-group">
                {hero.inlineGroup.map((item, i) => (
                  <div key={i}>
                    <div className={`h-val${item.valueClass ? ` ${item.valueClass}` : ''}${item.colorClass ? ` ${item.colorClass}` : ''}`}>
                      {item.value}
                    </div>
                    {item.sub && <div className="h-sub2">{item.sub}</div>}
                  </div>
                ))}
              </div>
            ) : (
              <div className={`h-val${hero.valueClass ? ` ${hero.valueClass}` : ''}${hero.colorClass ? ` ${hero.colorClass}` : ''}`}>
                {hero.value}
              </div>
            )}

            {hero.sub && <div className="h-sub">{hero.sub}</div>}
            {hero.sub2 && <div className="h-sub2">{hero.sub2}</div>}

            {hero.allocationBar && (
              <div className="alloc-row">
                {hero.allocationBar.map((seg, i) => (
                  <div key={i} className="alloc-s" style={{ flex: seg.flex, background: seg.color }} />
                ))}
              </div>
            )}

            {hero.momentumBar && (
              <div className="momentum-bar">
                <div style={{ flex: hero.momentumBar.up, background: '#3daa6e', height: 3 }} />
                <div style={{ flex: hero.momentumBar.rest, background: '#2a3040', height: 3 }} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TerminalHero;
